var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7004 23.8894C45.2999 26.139 47.0994 27.2637 47.7167 28.704C48.2557 29.9615 48.2557 31.3852 47.7167 32.643C47.0994 34.083 45.2999 35.2077 41.7004 37.4575L24.7949 48.0235C20.8001 50.5202 18.8026 51.7687 17.1543 51.636C15.7175 51.5205 14.4004 50.7907 13.5409 49.6335C12.5549 48.306 12.5549 45.9505 12.5549 41.2395V20.1074C12.5549 15.3964 12.5549 13.041 13.5409 11.7134C14.4004 10.5562 15.7175 9.82625 17.1543 9.71072C18.8026 9.57822 20.8001 10.8266 24.7949 13.3234L41.7004 23.8894Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.5120f28592a34a43b743ba5976cbbf1c.svg";
export { ForwardRef as ReactComponent };